import { Component, OnInit } from '@angular/core';
import { UploadService } from '../shared/upload.service';
import { Upload } from '../shared/upload';
import * as _ from "lodash";
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import { typeWithParameters } from '@angular/compiler/src/render3/util';
import * as firebase from 'firebase';
@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.css']
})
export class UploadFormComponent implements OnInit {
  selectedFiles: FileList;
  currentUpload: Upload;

  photoURL_bill;

  captureDataUrl:any;
  constructor(private upSvc: UploadService,public af: AngularFireDatabase,private db: AngularFireDatabase) { }
  private basePath:string = '/uploads';
  private uploadTask :firebase.storage.UploadTask;

  ngOnInit() {
  }

  detectFiles(event) {
    this.selectedFiles = event.target.files;
    console.log(this.selectedFiles)
  }

uploadSingle() {

//   const cameraOptions: CameraOptions = {
//     quality: 50,
//       destinationType: this.camera.DestinationType.DATA_URL,
//       sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
//       correctOrientation: true,
//       allowEdit: true,
//       targetHeight: 400,
//       targetWidth: 400
//   };

//   this.camera.getPicture(cameraOptions)
//   .then((picturebase64) => {
//     this.captureDataUrl = 'data:image/jpeg;base64,' + picturebase64;
//  }, (err) => {
//      console.log(err);
//  });



  let file = this.selectedFiles.item(0)

  this.currentUpload = new Upload(file);
  this.captureDataUrl =this.selectedFiles.item(0)

  const filename = Math.floor(Date.now() / 1000);  
  var NameImage = filename +'.jpeg'

  console.log(this.captureDataUrl);

  let storageRef = firebase.storage().ref().child(`images/${filename}.jpg`)
  storageRef.putString(this.captureDataUrl , firebase.storage.StringFormat.DATA_URL).then(res => {
   res.ref.getDownloadURL().then(URLIMG=>{
    this.photoURL_bill = URLIMG
    this.db.list('image').push({
      photoURL_bill : this.photoURL_bill,
    })          
    console.log('URLIMG : ',URLIMG)
   })
  }).catch(err => {
  
    alert("อัพโหลดภาพไม่สำเร็จ "+err);
  })



  // this.upSvc.pushUpload(this.currentUpload)
}

uploadMulti() {
  let files = this.selectedFiles
  let filesIndex = _.range(files.length)
  _.each(filesIndex, (idx) => {
    this.currentUpload = new Upload(files[idx]);
    this.upSvc.pushUpload(this.currentUpload)}
  )
}

}